const DoubleXPass = require("./doubleCards.png")
const x_pass_hd = require("./HD_TEST.png")
const BgColorBlend = require('./colorBlend.png') 
const Submited = require('./lottie-gif/submitted.json')

const Resource = {
    Card:{
        name:"X-passes",
        Location:x_pass_hd
    },
    DoubleCards:{
        Location:DoubleXPass
    },
    BgBlend:{
        Mix:BgColorBlend
    },
    icons:{
      
    },
    Animation:{
        submited:Submited
    }
}

export default Resource;